
export const editSetting = 'EDIT_SETTING';
export const editClientInfo = 'EDIT_CLIENT_INFO';
export const fetchCard = 'FETCH_BUSINESS_CARD_PENDING';
export const fetchCardSuccess =  'FETCH_BUSINESS_CARD_SUCCESS';
export const fetchCardError =  'FETCH_BUSINESS_CARD_ERROR';
export const resetCard = 'RESET_BUSINESS_CARD';
